export default "__VITE_ASSET__12fcd4ca__"